import { Clothes } from "./Clothes";
import { NocSizes } from "./NocSizes";
import { UseConditions } from "./UseConditions";

export class DataClothes {
    clothes: Clothes[];
    family: string;
    token: string;
    errorCode: {
        message: string,
        code: string
    };
    stockOut: number;
    detailStockOut: String[];
    nocSize: NocSizes;
    useConditions: UseConditions[];
    search: string[]
}